import { render, staticRenderFns } from "./ResetaSenha.vue?vue&type=template&id=d5562a8c&"
import script from "./ResetaSenha.vue?vue&type=script&lang=js&"
export * from "./ResetaSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports